import { useSupportTicketsQuery } from './useSupportTicketsQuery';

export interface InboxNavItem {
	key: string;
	label: string;
	count: number;
}

/**
 * Shared hook that fetches sidebar counts for the support inbox nav, scoped to a mailbox.
 */
export function useSupportInboxCounts(mailboxId: string): InboxNavItem[] {
	// Match the inbox page size so the active preset can share its first-page query with the visible list.
	const pageSize = 25;
	const { data: unassignedData } = useSupportTicketsQuery({ filter: 'unassigned', mailboxId, pageSize });
	const { data: mineData } = useSupportTicketsQuery({ filter: 'mine', mailboxId, pageSize });
	const { data: assignedData } = useSupportTicketsQuery({ filter: 'assigned', mailboxId, pageSize });
	const { data: spamData } = useSupportTicketsQuery({ filter: 'spam', mailboxId, pageSize });

	return [
		{ key: 'unassigned', label: 'Unassigned', count: unassignedData?.totalCount ?? 0 },
		{ key: 'mine', label: 'Mine', count: mineData?.totalCount ?? 0 },
		{ key: 'assigned', label: 'Assigned', count: assignedData?.totalCount ?? 0 },
		{ key: 'closed', label: 'Closed', count: 0 },
		{ key: 'spam', label: 'Spam', count: spamData?.totalCount ?? 0 },
		{ key: 'archive', label: 'Archive', count: 0 },
	];
}
